import { IonToggle } from "@ionic/react";
import { ComponentProps } from "react";

import styles from "@components/buttons/Toggle.module.css";
import BodyCopy from "@components/typography/BodyCopy";
import { Colors } from "@utils/colorUtils";

type ToggleProps = Pick<
  ComponentProps<typeof IonToggle>,
  "checked" | "disabled" | "labelPlacement" | "name" | "onIonChange"
> & {
  color?: Extract<Colors, "primary-300" | "primary-500">;
  label?: string;
  setValue: (value: boolean) => void;
  size?: "small" | "medium";
};

const Toggle = ({
  color = "primary-300",
  label,
  onIonChange,
  setValue,
  size = "medium",
  ...inputProps
}: ToggleProps) => {
  const wrapperStyles = [styles.toggle];

  if (size === "small") {
    wrapperStyles.push(styles.small);
  }

  return (
    <IonToggle
      className={wrapperStyles.join(" ")}
      color={color}
      labelPlacement="start"
      mode="ios"
      {...inputProps}
      onIonChange={e => {
        setValue(e.detail.checked);
        if (onIonChange) onIonChange(e);
      }}
    >
      {label && (
        <div>
          <BodyCopy color={inputProps.checked ? color : "gray-300"} size="small">
            {label}
          </BodyCopy>
        </div>
      )}
    </IonToggle>
  );
};

export default Toggle;
